module.exports = __webpack_public_path__ + "img/knife.7c6c482a.svg";